<style lang="scss" scoped>
body {
  margin: 0 auto;

}

#app {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
  .loading {
    width: 100%;
    height: 100%;
    background-image: url("../src/assets/public/loading.png");
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .loading-num {
      position: absolute;
      bottom: 472px;
      // display: flex;
      // align-items: center;
      font-weight: 500;
      font-size: 64px;
      line-height: 74px;
      letter-spacing: 0.05em;
      font-family: "dina";
      background: linear-gradient(359.39deg, #c4c4c4 -8.08%, #ffffff 81.51%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .pro-num {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 12px;
    }
  }
  .content {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  ::v-deep .el-progress-bar {
    .el-progress-bar__outer {
      background-color: #c4c4c4;
    }
  }
}
</style>

<template>
  <div id="app" @dragstart.prevent @selectstart.prevent>
    <fit-layout :width="1920" :height="1080">
      <div class="content">
        <!-- <router-view v-if="true"></router-view> -->
        <router-view v-if="showScene"></router-view>
        <div class="loading" v-else>
          <div class="loading-num">{{ proNum }}%</div>
          <div class="pro-num">
            <el-progress
              :percentage="proNum"
              color="#2D82FF"
              :stroke-width="12"
              :show-text="false"
            ></el-progress>
          </div>
        </div>
      </div>
      <three-scene @onDone="onDone" @loadProgress="loadProgress"></three-scene>
    </fit-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showScene: false,
      proNum: 0,
    };
  },
  mounted() {},
  methods: {
    onDone() {
      this.showScene = true;
      this.$store.state.threeLoad = true;
    },
    loadProgress(a) {
      this.proNum = a * 1;
    },
  },
};
</script>
